import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Chip,
  Typography,
  Paper,
  TextField,
  Button,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useStore } from "@store/store";
import { toast } from "react-toastify";
import API from "@services/axios";
import EmailIcon from "@mui/icons-material/Email"
import {
  UPDATE_ALLOCATOR_EMAIL,
  UPDATE_ALLOCATOR_EMAIL_SUCCESS,
  UPDATE_ALLOCATOR_EMAIL_FAILURE,
  FETCH_CUSTOMER_ID,
  FETCH_CUSTOMER_ID_SUCCESS,
  FETCH_CUSTOMER_ID_FAILURE
} from "@utils/actionTypes";
import { cargoWiseSettingsStyle } from "./style";
// Regex for email
const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function CargoWiseSettings(props) {
  const classes = cargoWiseSettingsStyle();
  const [scroll] = useState("body");
  const { id } = useParams();
  const [, dispatch] = useStore();
  const [emails, setEmails] = useState(props.allocatorEmails || []);
  const [error, setError] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [openPopup, setOpenPopup] = useState(false);

  const handleSetData = (emails) => {
    const newArray = emails;
    setEmails(newArray);
    let isError = false;
    if (newArray?.length > 0) {
      for (let i = 0; i < newArray.length; i++) {
        if (!re.test(newArray[i])) {
          isError = true;
          break;
        }
      }
      if (isError) {
        setError("One or more email addresses are invalid. Please check and try again.");
      } else {
        setError("");
      }
    }
  };

  const handleInputChange = (val) => {
    setInputValue(val);
  }

  const handleSave = () => {
    if (emails?.length === 0) {
      setOpenPopup(true);
      return;
    } else {
      updateAllocatorEmail(emails);
    }
  };

  const closePopup = () => {
    setOpenPopup(false);
  }

  const updateAllocatorEmail = (emails) => {
    closePopup();
    dispatch({
      type: UPDATE_ALLOCATOR_EMAIL,
    });
    API.put(`customers/${id}/allocatorEmails`, { allocatorEmails: emails })
      .then((response) => {
        dispatch({
          type: UPDATE_ALLOCATOR_EMAIL_SUCCESS,
          payload: response.data.data,
        });
        getCustomerDetail();
        toast.success("Allocator Email Updated Successfully");
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_ALLOCATOR_EMAIL_FAILURE,
          payload: error,
        });
        toast.error("Allocator Email Update Failed");
      });
  }
  const getCustomerDetail = () => {
    dispatch({ type: FETCH_CUSTOMER_ID });
    API.get(`customers/${id}`)
      .then((response) => {
        dispatch({
          type: FETCH_CUSTOMER_ID_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_CUSTOMER_ID_FAILURE, payload: error });
      });
  }

  return (
    <>
      <Paper className={classes.cargoWiseSettings}>
        <div className="cw-badge">CARGOWISE SETTINGS</div>

        <Typography variant="h2" className="cw-title">
          Allocator Email Configuration
        </Typography>

        <Typography variant="h6" component="p" className="cw-desc">
          Specify the email address that will receive operational alerts and
          notifications when new CargoWise jobs and AWBs are received.
        </Typography>

        <div className="cw-form">
          <Autocomplete
            multiple
            freeSolo
            disableClearable
            options={[]}
            value={emails}
            inputValue={inputValue || ""}
            onInputChange={(e, newInputValue) => {
              handleInputChange(newInputValue);
            }}
            onChange={(e, newValue) => {
              handleSetData(newValue);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  label={option}
                  {...getTagProps({ index })}
                  className="cw-chip"
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Press enter to add email"
                size="small"
                variant="standard"
                error={!!error}
                helperText={error}
                className="cw-input-email"
                onBlur={(event) => {
                  const newTag = event.target.value.trim();
                  if (newTag) {
                    handleSetData([...(emails || []), newTag]);
                  }
                  setInputValue("");
                }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <InputAdornment position="start">
                        <EmailIcon fontSize="small" />
                      </InputAdornment>
                      {params.InputProps.startAdornment}
                    </>
                  )
                }}
              />
            )}
            className="cw-input"
          />

          <Button className="orange-btn primary-btn" onClick={handleSave} disabled={!!error}>
            SAVE
          </Button>
        </div>
      </Paper>
      <Dialog
        open={openPopup}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <Typography variant="h6" component="p" gutterBottom>
              All allocator email recipients have been cleared.
            </Typography>
            <Typography variant="h6" component="p" gutterBottom>
              As a result, notifications for this customer will stop.
            </Typography>
            <Typography variant="h6" component="p" gutterBottom>
              Do you want to proceed?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closePopup}
            color="primary"
            className="primary-btn gray-border-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={() => updateAllocatorEmail([])}
            color="primary"
            className="orange-btn primary-btn center-loading-indicator"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CargoWiseSettings;